import { render, staticRenderFns } from "./RecordLabelEditForm.vue?vue&type=template&id=3ade4f60"
import script from "./RecordLabelEditForm.vue?vue&type=script&lang=js"
export * from "./RecordLabelEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports